// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"ffc24f12","498":"22b4d868","703":"3bf41822","787":"983e1ff2"}[chunkId] + ".chunk.js";
};